import { Container, Row, Col } from "react-bootstrap";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import Businessprofiletitle from "../../components/BusinessProfile/Component/Title/businessprofiletitle";
import Rawmaterialcard from "../../components/BusinessProfile/Component/Rawmaterialcard/Rawmaterialcard";
import Timeline from "../../components/Timeline/timeline";
import ShopAdds from "../../components/shopAds/ShopAdds";
import BackArrow from "../../components/backArrow";
import { useSelector } from "react-redux";
import Viewbusinessfriend from "../../pages/UserProfile/Components/Profile_connectivity/Viewbusiness/index";
import { useEffect, useState } from "react";
import { decodeId } from "../../utils/idObfuscator";
import { useBusinessProfileTabs } from "../../hooks/useBusinessProfileTabs";
import useIncomingMessageNotice from "../../hooks/useIncomingMessageNotice";
import "./serviceprofile.css";

const Servicebusinessprofile = () => {
  const { id: rawId } = useParams();
  const id = decodeId(rawId) || rawId;
  const location = useLocation();
  const navigate = useNavigate();
  const [profileshowhide, setProfileshowhide] = useState(false);
  const { name } = useSelector((state) => state.user);
  const { receivedMessageCount, clearReceivedMessageCount } =
    useIncomingMessageNotice({ userId: name?._id, shopId: id });

  const handleOpenChat = () => {
    clearReceivedMessageCount();
    const chatParams = new URLSearchParams({
      type: "shop",
      profileId: id || "",
      businessType: "services",
      returnTo: location.pathname,
    });
    const chatUrl = `/messages?${chatParams.toString()}`;
    const newTab = window.open(chatUrl, "_blank");
    if (!newTab) {
      navigate("/messages", {
        state: {
          returnTo: location.pathname,
          messageProfile: {
            type: "shop",
            profileId: id,
            businessType: "services",
          },
        },
      });
    }
  };

  const [createPost, setCreatePost] = useState({
    shopid: id,
    userid: name?._id,
    businessType: "services",
    my: [
      {
        heading: "",
        content: "",
        img: [""],
        video: [""],
      },
    ],
  });

  useEffect(() => {
    setCreatePost((prev) => ({
      ...prev,
      shopid: id || prev.shopid,
      userid: name?._id || prev.userid,
      businessType: "services",
    }));
    if (id) localStorage.setItem("shopid", id);
  }, [id, name?._id]);

  const {
    tabsData,
    activeTab,
    handleTabSelect,
    getActiveTabData,
    loading,
  } = useBusinessProfileTabs({
    shopid: id,
    userid: name?._id,
    businessType: "services",
  });

  return (
    <>
      <Container className="service-business-profile">
        <Row className="service-business-profile-row align-items-start">
          <Col lg="7" className="screenHeight p-0">
            {profileshowhide ? (
              <Viewbusinessfriend
                id={id}
                profileurl="/Home-Made-Item-Userprofile"
                setProfileshowhide={setProfileshowhide}
                mybusinessType={createPost?.businessType}
                viewBusinessType={profileshowhide}
              />
            ) : (
              <div className="service-business-profile-panel border b-radius">
                <div className="ms-3">
                  <BackArrow />
                </div>

                <ShopAdds />
                <Businessprofiletitle
                  linkurl="/services-profile"
                  id={id}
                  name="Service Business Profile"
                />
                <Rawmaterialcard
                  id={id}
                  setProfileshowhide={setProfileshowhide}
                />
              </div>
            )}
          </Col>

          <Col
            lg="5"
            sm="12"
            className="ps-4 screenHeight"
            style={{ position: "relative" }}
          >
            <div className="service-business-profile-panel border b-radius">
              <Timeline
                tabsData={tabsData}
                activeTab={activeTab || "home"}
                onTabSelect={handleTabSelect}
                tabData={getActiveTabData()}
                loading={loading}
                createPost={createPost}
                setCreatePost={setCreatePost}
                id={id}
                mybusinessType={createPost?.businessType}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default Servicebusinessprofile;
